import Axios from '../request';
import store from '@/store';
import { EUS_HOST } from '@/config/host';
const urlParams = store.state.app.urlParams;

const loading = {
  showLoading: '加载中',
};

// 取消订单
export function fetchCancelOrder(params) {
  return Axios.post(
    '',
    {
      name: 'user.order.cancel',
      data: JSON.stringify(params),
    },
    loading,
  );
}

// 请求更换司机
export function fetchChangeDriver(params) {
  return Axios.post(
    '',
    {
      name: 'user.order.change.driver',
      data: JSON.stringify(params),
    },
    loading,
  );
}

// 取消原因列表
export function fetchCancelOrderReasonList(params) {
  const isCompany = urlParams.ep_id || false;
  console.info(urlParams, 'urlParams');
  return Axios.post(
    isCompany ? EUS_HOST : '',
    {
      name: 'cancel.reason.list.new',
      data: JSON.stringify(params),
    },
    loading,
  );
}

// 提交取消原因
export function fetchSubmitCancelOrderReason(params) {
  const isCompany = urlParams.ep_id || false;
  return Axios.post(
    isCompany ? EUS_HOST : '',
    {
      name: 'user.order.cancel.reason',
      data: JSON.stringify(params),
    },
    loading,
  );
}

// 获取取消订单标题
export function fetchCancelOrderTitle(params) {
  return Axios.post('', {
    name: 'user.order.cancel.remind',
    data: JSON.stringify(params),
  });
}
